import { Solutions } from "src/pages/home/sections/Solutions";
import { RegisterSection } from "src/pages/home/sections/RegisterSection";

export const SolutionsPage = () => (
  <section className="padding max-container">
    <Solutions />
    <RegisterSection/>
  </section>
);
